import { loadJsonFileIntoSessionStorage } from '../../tools/helpers';

let filterArr = [];

class ContentHubFilter {
  constructor(options = {}) {
    this.element = options.element;
    this.articlesLabelSingular = this.element.dataset.articlesLabelSingular || 'Beiträge';
    this.articlesLabelPlural = this.element.dataset.articlesLabelPlural || 'Beitrag';
    this.allTopicsLabel = this.element.dataset.allTopicsLabel || 'in allen Themen';
    this.storiesJsonURL = this.element.dataset.storiesJsonPath;
    this.FILTER_STATE_LABEL = 'filterState';
    this.allFilterButtonDesktop = this.element.querySelector('#select-all-isDesktop.category-filter');
    this.allFilterButtonMobile = this.element.querySelector('#select-all-isMobile.category-filter');
  }

  init() {
    const filterListDesktop = this.element.querySelectorAll('.isDesktop');
    const filterListMobile = this.element.querySelectorAll('.isMobile');
    const confirmFilterButton = this.element.querySelector('.filter-modal__confirm-btn');
    const closeModalButton = this.element.querySelector('.close-btn');
    const openModalButton = this.element.querySelector('.filter-modal__opener-btn');
    const filterModal = this.element.querySelector('.filter-modal');

    const loadedFilterState = sessionStorage.getItem(this.FILTER_STATE_LABEL);
    let activateAllArticlesChip = false;
    if (loadedFilterState) {
      const filterListDesktopAndMobile = this.element.querySelectorAll('.isDesktop, .isMobile');
      this.parseLoadedFilterState(loadedFilterState, filterListDesktopAndMobile);
      this.setFilterSelectionInHTML(filterArr);
      this.changeArticleCount(filterArr).then(articleCount => this.setArticleCountInHTML(articleCount));

    } else {
      this.getCountOfAllArticles().then(articleCount => this.setArticleCountInHTML(articleCount));
      activateAllArticlesChip = true;
    }

    this.setActiveStateInSelectAllButtons(activateAllArticlesChip);

    // add event listeners
    this.filterElements(filterListDesktop, this.allFilterButtonDesktop, activateAllArticlesChip);
    this.filterElements(filterListMobile, this.allFilterButtonMobile, activateAllArticlesChip);

    openModalButton.addEventListener('click', () => {
      filterModal.classList.remove('hide-element');
      document.body.style.overflow = 'hidden';
      sessionStorage.setItem('activeFilterModal', JSON.stringify(filterArr));
    });

    closeModalButton.addEventListener('click', () => {
      const activeFilters = JSON.parse(sessionStorage.getItem('activeFilterModal'));
      this.setActiveIDs(activeFilters);

      if (!filterArr.length) {
        this.getCountOfAllArticles().then(articleCount => this.setArticleCountInHTML(articleCount));
        this.setActiveStateInSelectAllButtons(true);
        this.emptyFilterStateInSessionStorage();
      } else {
        this.setActiveStateInSelectAllButtons(false);
        this.changeArticleCount(filterArr).then(articleCount => this.setArticleCountInHTML(articleCount));
        this.setFilterStateInSessionStorage(filterArr);
      }

      this.setFilterSelectionInHTML(filterArr);
      filterModal.classList.add('hide-element');
      document.body.style.overflow = 'scroll';
    });

    confirmFilterButton.addEventListener('click', () => {
      filterModal.classList.add('hide-element');
      document.body.style.overflow = 'scroll';
    });
  }

  setActiveIDs(IDList) {
    const dataIDs = IDList.map(item => item.data.id);

    const categoryButtons = document.querySelectorAll('.category-filter.isMobile');
    categoryButtons.forEach((entry) => {
      const dataID = entry.getAttribute('data-id');

      if (!dataIDs.includes(dataID)) {
        entry.classList.remove('isActive');
        this.removeFilterFromArr(entry.dataset.id);
        this.changeActiveStateInSibling(entry.dataset.id, false);
      } else {
        entry.classList.add('isActive');

        this.changeActiveStateInSibling(entry.dataset.id, true);
        const activeElement = { html: entry, data: entry.dataset };
        const itemIsIncludedInFilterArr = filterArr.some(item => item.data.id === activeElement.data.id);
        if (!itemIsIncludedInFilterArr) {
          filterArr.push(activeElement);
        }
      }
    });
  }

  parseLoadedFilterState(loadedFilterState, filterList) {
    JSON.parse(loadedFilterState).forEach((element) => {
      filterList.forEach((button) => {
        if (element.data.id === button.dataset.id) {
          this.setToOrRemoveFromFilterArrDependingOnClassAtElement(button, 'isActive');
          this.changeActiveStateInSibling(element.data.id, true);
        }
      });
    });
  }

  filterElements(filterList, allFilterButton, activateAllArticlesChip) {
    filterList.forEach((element) => {

      if (activateAllArticlesChip && (element.dataset.id === 'select-all-isMobile' || element.dataset.id === 'select-all-isDesktop')) {
        element.classList.add('isActive');
      }

      element.addEventListener('click', () => {
        this.changeActiveStateInSibling(element.dataset.id, true);

        // check if "all" is selected
        if (element.dataset.id === 'select-all-isMobile' ||
          element.dataset.id === 'select-all-isDesktop') {
          this.deselectAllFilters('isActive');
          this.getCountOfAllArticles().then(articleCount => this.setArticleCountInHTML(articleCount));
          this.setActiveStateInSelectAllButtons(true);
          this.emptyFilterStateInSessionStorage();

        // check if a specific filter is selected
        } else {
          this.handleSelectedFilter(element, 'isActive');
          this.changeArticleCount(filterArr).then(articleCount => this.setArticleCountInHTML(articleCount));
          this.setActiveStateInSelectAllButtons(false);
          this.setFilterStateInSessionStorage(filterArr);
        }

        // check if all single filters are selected
        if (filterList.length - 1 === filterArr.length) {
          // sets filterArr to []
          this.deselectAllFilters('isActive');
          this.setActiveStateInSelectAllButtons(true);
          this.emptyFilterStateInSessionStorage();
        }

        // check if no single filter is selected
        if (!filterArr.length) {
          this.getCountOfAllArticles().then(articleCount => this.setArticleCountInHTML(articleCount));
          this.setActiveStateInSelectAllButtons(true);
          this.emptyFilterStateInSessionStorage();
        }

        if (filterArr.length && filterList.length - 1 > filterArr.length) {
          this.setActiveStateInSelectAllButtons(false);
        }

      });
    });
  }

  getSiblingIdFromId(idOfButton) {
    return idOfButton.includes('isMobile') ?
      idOfButton.replace('isMobile', 'isDesktop') :
      idOfButton.replace('isDesktop', 'isMobile');
  }

  changeActiveStateInSibling(idOfButton, isActive) {
    const buttonElement = document.getElementById(`${this.getSiblingIdFromId(idOfButton)}`);

    if (!isActive) {
      buttonElement.classList.remove('isActive');
    } else {
      buttonElement.classList.add('isActive');
    }
  }

  handleSelectedFilter(element, className) {
    this.setToOrRemoveFromFilterArrDependingOnClassAtElement(element, className);
    this.setFilterSelectionInHTML(filterArr);
  }

  setToOrRemoveFromFilterArrDependingOnClassAtElement(element, className) {
    if (element.classList.contains(className)) {
      element.classList.remove(className);
      this.removeFilterFromArr(element.dataset.id);
    } else {
      element.classList.add(className);
      filterArr.push({ html: element, data: element.dataset });
    }
  }

  deselectAllFilters(className) {
    filterArr.forEach((filter) => {
      filter.html.classList.remove(className);
      this.changeActiveStateInSibling(filter.html.id, false);
    });

    filterArr = [];
    this.setFilterSelectionInHTML(filterArr);
  }

  removeFilterFromArr(filterId) {
    filterArr.forEach((filter, index) => {
      if (filter.data.id === filterId) {
        filterArr.splice(index, 1);
        this.changeActiveStateInSibling(filterId, false);
      }
    });
  }

  async getCountOfAllArticles() {
    if (!sessionStorage.getItem('storyJson')) {
      await this.loadStoriesFromJson();
    }

    // load json data from session storage
    const dataFromSessionStorage = sessionStorage.getItem('storyJson');

    let articleCount = 0;
    if (dataFromSessionStorage != null) {
      const stories = JSON.parse(dataFromSessionStorage);
      articleCount = stories.stories.length;
    }

    return articleCount;
  }

  async changeArticleCount(filterArray) {
    if (!sessionStorage.getItem('storyJson')) {
      await this.loadStoriesFromJson();
    }

    // load json data from session storage
    const dataFromSessionStorage = sessionStorage.getItem('storyJson');

    let articleCount = 0;
    if (dataFromSessionStorage != null) {
      const storiesJSON = JSON.parse(dataFromSessionStorage);

      articleCount = storiesJSON.stories
        .filter((story) => {
          let isFiltered = false;
          filterArray.forEach((element) => {
            isFiltered = isFiltered || story.topic.indexOf(element.data.label) >= 0;
          });
          return isFiltered;
        })
        .length;
    }

    return articleCount;
  }

  setArticleCountInHTML(count) {
    const htmlString = (count === 1) ? `${count} ${this.articlesLabelSingular}` : `${count} ${this.articlesLabelPlural}`;
    const counterElement = this.element.querySelectorAll('#articleCounter');
    counterElement[0].innerHTML = htmlString;
  }

  setFilterSelectionInHTML(selectedFiltersArr) {
    let htmlString = '';
    selectedFiltersArr.forEach((filter) => {
      const filterString = `${filter.data.label}, `;
      htmlString += filterString;
    });

    htmlString = htmlString.substring(0, htmlString.length - 2);

    htmlString = htmlString ? `in ${htmlString}` : this.allTopicsLabel;
    const selectedFilterElement = this.element.querySelectorAll('#selectedFilter');
    selectedFilterElement[0].innerHTML = htmlString;
  }

  setActiveStateInSelectAllButtons(isActive) {
    if (this.allFilterButtonDesktop || this.allFilterButtonMobile) {
      if (isActive) {
        this.allFilterButtonDesktop.classList.add('isActive');
        this.allFilterButtonDesktop.classList.add('hide-number');
        this.allFilterButtonMobile.classList.add('isActive');
        this.allFilterButtonMobile.classList.add('hide-number');
      } else {
        this.allFilterButtonDesktop.classList.remove('isActive');
        this.allFilterButtonDesktop.classList.add('hide-number');
        this.allFilterButtonMobile.classList.remove('isActive');
        this.allFilterButtonMobile.classList.add('hide-number');
      }
    }
  }

  async loadStoriesFromJson() {
    await loadJsonFileIntoSessionStorage(this.storiesJsonURL, 'storyJson');
  }

  setFilterStateInSessionStorage(filterStateArray) {
    sessionStorage.setItem(this.FILTER_STATE_LABEL, JSON.stringify(filterStateArray));
  }

  emptyFilterStateInSessionStorage() {
    sessionStorage.removeItem(this.FILTER_STATE_LABEL);
  }
}

export default ContentHubFilter;
